/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SecretariatMembersSubmissionsCycles } from '../../models/secretariat-members-submissions-cycles';

export interface GetSecretariatMemberSubmissionsCyclesApiV2SecretariatMembersOrgIdSubmissionsCyclesGet$Params {
  orgId: string;
  org: string;
}

export function getSecretariatMemberSubmissionsCyclesApiV2SecretariatMembersOrgIdSubmissionsCyclesGet(http: HttpClient, rootUrl: string, params: GetSecretariatMemberSubmissionsCyclesApiV2SecretariatMembersOrgIdSubmissionsCyclesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<SecretariatMembersSubmissionsCycles>> {
  const rb = new RequestBuilder(rootUrl, getSecretariatMemberSubmissionsCyclesApiV2SecretariatMembersOrgIdSubmissionsCyclesGet.PATH, 'get');
  if (params) {
    rb.path('orgId', params.orgId, {});
    rb.query('org', params.org, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SecretariatMembersSubmissionsCycles>;
    })
  );
}

getSecretariatMemberSubmissionsCyclesApiV2SecretariatMembersOrgIdSubmissionsCyclesGet.PATH = '/api/v2/secretariat/members/{orgId}/submissions-cycles';
